import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-info-card',
	templateUrl: './info-card.component.html',
	styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent {
	@Input() imageThumbnail: string | null = '';
	@Input() imageMode: boolean = false; // render the image block (with placeholder when no image) even when imageThumbnail is null
	@Input() itemName: string = '';
	@Input() title: string = '';
	@Input() info: any;
	@Input() keys: string[] = []; // keys to be displayed
	@Input() labels: Record<string, { text: string; pipe?: string }> = {}; // map keys to labels and optional pipes
	@Input() extraProps: Record<string, any> = {}; // additional key-value pairs not part of info object to display
	@Input() layout: 'row' | 'column' | 'twoByTwo' | 'grid' = 'row';
	@Input() gridColumns: number = 2; // number of columns for grid layout
	@Input() gridColClass: string = '';
	@Input() grid: string = '';
	@Input() buttonLabel: string = 'Edit'; // label for the button (default: 'Edit')
	@Input() buttonIcon: string = 'pi-pencil';
	@Input() hideButton: boolean = false;
	@Input() showDropdown: boolean = false;
	@Input() itemActionMenu: { label: string; icon?: string; command: () => void }[] = [];
	@Output() buttonClick = new EventEmitter<void>();
	@Output() edit = new EventEmitter<void>();
	@Output() imageAction = new EventEmitter<void>(); // camera overlay / dashed placeholder click → upload or replace image

	get gridColumnsStyle(): string {
		return `repeat(${this.gridColumns}, 1fr)`;
	}

	isArray(value: any): boolean {
		return Array.isArray(value);
	}

	displayValue(value: any): string {
		if (value === null || value === undefined || value === '' || value?.toString().includes('N/A')) {
			return '-';
		}

		if (value === 0) {
			return '0';
		}
		return value.toString();
	}

	defaultImage = 'https://dmehs.s3.us-west-2.amazonaws.com/images/photoComingSoon.png'; // Or any placeholder path
	showPreview = false;
	onImageError(event: Event) {
		const target = event.target as HTMLImageElement;
		target.src = this.defaultImage;
	}
}
